import React from "react";
import { IconSearch, SearchUser } from "~misc/icons";
import FilterSelect from "./FilterSelect";

const ClientesFilterBar = ({
  searchValue = "",
  onSearchValueChange,
  onSearchSubmit,
  searchPlaceholder = "Busque por Código de Cliente, Razão Social ou Grupo Centralizador",
  mesValue,
  onMesChange,
  mesOptions = [],
  grupoProdutoValue,
  onGrupoProdutoChange,
  grupoProdutoOptions = [],
  produtoValue,
  onProdutoChange,
  produtoOptions = [],
  showClearButton = false,
  onClearFilters,
}) => {
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      onSearchSubmit?.(searchValue);
    }
  };

  return (
    <div className="container space-y-2">
      <div className="flex items-end gap-3">
        <div className="relative flex-1">
          <SearchUser className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2" />
          <input
            value={searchValue}
            placeholder={searchPlaceholder}
            onChange={(e) => onSearchValueChange?.(e.target.value)}
            onKeyDown={handleKeyDown}
            className="h-11 w-full rounded-md border border-[#C8CED8] bg-white pl-10 pr-11 text-sm text-[#1A2B49] outline-none"
          />
          <button
            type="button"
            onClick={() => onSearchSubmit?.(searchValue)}
            className="absolute right-3 top-1/2 -translate-y-1/2"
            aria-label="Pesquisar"
          >
            <IconSearch className="h-4 w-4" />
          </button>
        </div>

        {mesOptions.length > 0 && (
          <div className="w-56 shrink-0">
            <FilterSelect
              id="mes-clientes"
              label="Selecione o mês desejado:"
              value={mesValue}
              onChange={onMesChange}
              options={mesOptions}
            />
          </div>
        )}
      </div>

      {(grupoProdutoOptions.length > 0 || produtoOptions.length > 0) && (
        <div className="flex items-end gap-3">
          {grupoProdutoOptions.length > 0 && (
            <div className="flex-1">
              <FilterSelect
                id="grupo-produto-clientes"
                label="Grupo de Produtos"
                value={grupoProdutoValue}
                onChange={onGrupoProdutoChange}
                options={grupoProdutoOptions}
              />
            </div>
          )}
          {produtoOptions.length > 0 && (
            <div className="flex-1">
              <FilterSelect
                id="produto-clientes"
                label="Produtos"
                value={produtoValue}
                onChange={onProdutoChange}
                options={produtoOptions}
              />
            </div>
          )}
          {showClearButton && (
            <button
              type="button"
              onClick={onClearFilters}
              className="h-11 shrink-0 rounded-md border border-[#C8CED8] bg-white px-4 text-sm font-semibold text-[#1A2B49] hover:bg-gray-50"
            >
              Limpar filtros
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default React.memo(ClientesFilterBar);
